import React, { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import { BrowserRouter } from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import { store } from './app/store/store';
import reportWebVitals from './reportWebVitals';
import { StorageHelper } from './utils/storageHelper';
import Loader from './app/core/components/shared/Loader/Loader';
import _ from 'underscore';
import * as UtilsHelper from "../src/utils/utilsHelper";

const Root = () => {
  const { isSwitching } = useSelector(store => store.template)
  const { isloaded } = useSelector(store => store.auth)
  useEffect(() => {
    UtilsHelper.loadAppSettings();
  }, []);

  if (_.isEmpty(StorageHelper.getAppSettings()) || isSwitching || isloaded) {
    return <div className='initial-loader'><Loader /></div>
  }
  return <App />
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<Loader width={"100%"} height={"100%"} />}>
      <Provider store={store}>
        <BrowserRouter>
          <Root />
        </BrowserRouter>
      </Provider>
    </Suspense>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
